<form
  class="reference-data-form"
  [formGroup]="form"
  (ngSubmit)="onSubmit()"
  (keydown.enter)="$event.preventDefault()"
>
  @if (loading) {
    <app-circular-spinner [whiteBackground]="true"></app-circular-spinner>
  }

  <!-- SITE & LEVEL 1 PERIMETERS ACCORDIONS -->
  <nb-accordion multi class="custom-accordion mt-0">
    @for (elt of (refDataByPerimeter$ | async); track elt.perimeter.id; let first = $first) {
      <nb-accordion-item [expanded]="focusedPerimeterId ? elt.perimeter.id === focusedPerimeterId : first">
        <nb-accordion-item-header>
          <span class="text">
            @if (!elt.perimeter.is_monosite) {
              {{ "Site" | translate }}
            } @else {
              {{ elt.perimeter.name}}
            }
          </span>
        </nb-accordion-item-header>
        <nb-accordion-item-body>
          <div class="row m-0">
            @for (refData of elt.refData; track refData.var_name) {
              <app-ref-data-input
                class="col-6"
                [refData]="refData"
                [formControlName]="refData.var_name"
              ></app-ref-data-input>
            }
          </div>
          <!-- LEVEL 2 PERIMETERS ACCORDIONS -->
          <!-- Disabled. Let's wait a little to see if Jerome wants the feature back -->
          <!-- @if (!!elt.children?.length) {
            <nb-accordion multi class="custom-accordion custom-accordion-children mt-5">
              @for (perimeter2 of elt.children; track perimeter2.perimeter.id) {
                <nb-accordion-item [expanded]="!!perimeter2.refData?.length">
                  <nb-accordion-item-header>
                    <span class="text">
                      @if (!perimeter2.perimeter.is_monosite) {
                        {{ "Site" | translate }}
                      } @else {
                        {{ perimeter2.perimeter.name}}
                      }
                    </span>
                  </nb-accordion-item-header>
                  <nb-accordion-item-body>
                    <div class="row m-0">
                      @for (refData of perimeter2.refData; track refData.var_name) {
                        <app-ref-data-input
                          class="col-6"
                          [refData]="refData"
                          [formControlName]="refData.var_name"
                        ></app-ref-data-input>
                      }
                    </div>
                  </nb-accordion-item-body>
                </nb-accordion-item>
              }
            </nb-accordion>
          } -->
        </nb-accordion-item-body>
      </nb-accordion-item>
    }
  </nb-accordion>

 
</form>
